import { FootballMatch } from '../../types/api/FootballMatch';
import { Paper } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface MatchCardProps {
    match: FootballMatch
}

export function MatchCard(MatchCardProps: MatchCardProps) {
    const { match } = MatchCardProps;
    
    return (
        <Paper className="rounded shadow p-4 flex flex-col gap-1 bg-gradient-to-r from-maroon-700 to-maroon-900 text-white">
            <span className="font-bold text-lg flex items-center gap-2">
                <SportsSoccerIcon />
                {match.homeTeam} vs {match.awayTeam}
            </span>
            <span className="flex items-center gap-2">
                <AccessTimeIcon />
                
                    {match.date} {match.time}
                    {!match.isDateConfirmed && (
                        <span className="ml-2 text-yellow-400 flex items-center gap-1">
                            <HelpOutlineIcon fontSize="small" />
                            <span className="text-sm">Date provisoire</span>
                        </span>
                    )}
    
            </span>
            <span className="text-sm opacity-80">
                📍 {match.location}
            </span>
        </Paper>
    );
}

export default MatchCard;